var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPopup)?_c('v-uni-view',{staticClass:"uni-popup"},[_c('v-uni-view',{staticClass:"uni-popup__mask",class:[_vm.ani, _vm.animation ? 'ani' : '', !_vm.custom ? 'uni-custom' : ''],on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.close(true)
},"touchmove":function($event){$event.stopPropagation();$event.preventDefault();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.moveHandle).apply(void 0, arguments)
}}}),_c('v-uni-view',{staticClass:"uni-popup__wrapper",class:[_vm.type, _vm.ani, _vm.animation ? 'ani' : '', !_vm.custom ? 'uni-custom' : ''],on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.close(true)
}}},[_c('v-uni-view',{staticClass:"uni-popup__wrapper-box",on:{"click":function($event){$event.stopPropagation();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clear).apply(void 0, arguments)
}}},[_vm._t("default")],2)],1)],1):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }